module.exports = __webpack_public_path__ + "img/img_lb_brand.6ed48362.png";